import { createContext, use } from 'react';

type SidebarContextType = {
  mode: 'expanded' | 'collapsed';
  onItemFocus?: () => void;
  isMobileView?: boolean;
  activePath?: string;
  setActivePath: (path: string) => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = SidebarContext.Provider;

export const useSidebarContext = () => {
  const context = use(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebarContext must be used within a SidebarProvider');
  }
  return context;
};
